// extracted by mini-css-extract-plugin
module.exports = {"cwzwg9s":"cwzwg9s","c1g924m":"c1g924m","c1jci1d9":"c1jci1d9"};